import { render, staticRenderFns } from "./HeaderLanding.vue?vue&type=template&id=521ccf24&scoped=true&"
import script from "./HeaderLanding.vue?vue&type=script&lang=js&"
export * from "./HeaderLanding.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLanding.vue?vue&type=style&index=0&id=521ccf24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521ccf24",
  null
  
)

export default component.exports